import { render } from "./DefaultTemplate.vue?vue&type=template&id=1ea36176"
import script from "./DefaultTemplate.vue?vue&type=script&lang=js"
export * from "./DefaultTemplate.vue?vue&type=script&lang=js"

import "./DefaultTemplate.vue?vue&type=style&index=0&id=1ea36176&lang=scss"

import exportComponent from "/var/www/documentation.probabilityworks.cloud/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__